export function calendarSourceDefaults(mode, activeTeamId) {
  if (mode === 'personal') return {personal: true, defaultTeams: false, teams: {}};
  if (mode === 'activeTeam' || mode === 'team') return {personal: false, defaultTeams: false, teams: activeTeamId ? {[activeTeamId]: true} : {}};
  return {personal: true, defaultTeams: true, teams: {}};
}
export function readCalendarSources(storage, userId, activeTeamId) {
  try {
    const saved = JSON.parse(storage?.getItem(`calendar.sources.v1.${userId}`) || 'null');
    if (saved && typeof saved.personal === 'boolean' && typeof saved.defaultTeams === 'boolean' && saved.teams && typeof saved.teams === 'object' && !Array.isArray(saved.teams)) {
      return {...saved, teams: Object.fromEntries(Object.entries(saved.teams).filter(([, checked]) => typeof checked === 'boolean'))};
    }
  } catch { /* A blocked or malformed preference must not hide the calendar. */ }
  let legacy;try {legacy = storage?.getItem('calendarViewMode');} catch {}
  return calendarSourceDefaults(legacy, activeTeamId);
}
export const calendarTeamSelected = (selection, id) => selection.teams[id] ?? selection.defaultTeams;
export function filterCalendarSources(events, selection, activeTeamId) {
  const teams = [...(events.allTeams || [])];
  if (activeTeamId && !teams.some(event => event.__teamId === activeTeamId)) teams.push(...(events.team || []).map(event => ({...event, __teamId: activeTeamId})));
  return [
    ...(selection.personal ? (events.personal || []).map(event => ({...event, calendar: 'personal'})) : []),
    ...teams.filter(event => calendarTeamSelected(selection, event.__teamId || activeTeamId)).map(event => ({...event, calendar: 'team'})),
  ];
}
